import React, {Component, useContext, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { Button, ButtonClose, ButtonDownload, ButtonCancel } from '../../../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../../../layouts';
import Welcome from '../../../../layouts/welcome';
import Row from '../../../../components/row';
import Container from '../../../../layouts/containers/container';
import List from '../../../../components/list';
import ContainerTable from '../../../../layouts/containers/container-table';
import { stringToFriendlyDatetime, getDSTLocalTime } from '../../../../lib/helpers/datetime-helpers';
import LabelContainer from '../../../../components/label-container';
import Divider from '../../../../components/divider/divider';

import ButtonModify from '../../../../components/buttons/button-modify';
import meetingsApi from '../../../../lib/meetings/meetings-api';
import PopupContext from '../../../../context/context-popup';

import MediaHelper from '../../../../lib/helpers/media';
import companiesApi from '../../../../lib/companies/companies-api';

import StatusBar from '../../../../components/status-bar';
import coWorkingApi from '../../../../lib/co-working/co-working-api';
import PopupsCancelBooking from '../../popups/popups-cancel-booking';
import BillingDetails from '../../../../components/billing-profile';

const YourDetails = ({ booker }) => {
    const Item = ({ title, value }) => {
        return (
            <List gap='10px' style={{ flex: '1 0 0' }}>
                <LabelContainer label={title}>
                    { value }
                </LabelContainer>
            </List>
        )
    }

    const Flex = ({ direction, children }) => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: direction,
                gap: '20px',
            }}>
                { children }
            </div>
        )
    }

    const profile = booker?.billing_profile;

    return (
        <Container>
            <Container.Header>
                <Container.Text color="#FF6933" fontSize="18px">Your Billing Details</Container.Text>
            </Container.Header>

            <Container.Content>
                <Flex direction="column">
                    <Flex direction="row">
                        <Item title="First Name" value={profile?.first_name}/>
                        <Item title="Last Name" value={profile?.last_name}/>
                    </Flex>
                    <Flex direction="row">
                        <Item title="Company" value={profile?.company_name}/>
                    </Flex>
                    <Item title="Email Address" value={profile?.email_address}/>
                    <Flex direction="row">
                        <Item title="Telephone Number" value={profile?.tel_no}/>
                        <Item title="SAP Number" value={profile?.sap_number}/>
                    </Flex>
                </Flex>
            </Container.Content>
        </Container>
    )
}

const Summary = ({
    costs = null,
    receipt = null,
}) => {
    const data = []

    if (costs !== null || receipt !== null) {
        const items = costs?.saved_quote_line_items || receipt?.receipt_line_items;

       items?.forEach((item, index) => {
            let cost = ``;

            if (item?.credits_used !== 0) {
                cost = `${item?.credits_used} credits` 
            }

            if (item?.total !== 0) {
                cost = `£${item?.total}`;
            }

            if (item?.credits_used > 0 && item?.total > 0) {
                cost = `£${item?.total} + ${item?.credits_used} credit(s)`
            }

            data.unshift([
                item?.quantity,
                item?.description,
                cost,
            ])
        })
    }

    return (
        <ContainerTable
            showMobileColumns
            headerColor="#d5d5d5"
            valueColor='white'
            className="table-white"
            columns={[
                { field: 'QTY', width: '25%' },
                { field: 'Item', width: '50%' },
                { field: 'Price/Credit(s)', width: '25%' },
            ]}
            data={[
                ...data
            ]}
        />
    )
}

const TopRightBar = ({ booking, fetch }) => {
    const { setPopup } = useContext(PopupContext);

    const goBack = () => window.history.back();

    const cancelBooking = () => {
        setPopup(<PopupsCancelBooking booking={booking} refresh={fetch}/>);
    }

    return (
        <Row gap="20px" wrap>
            <ButtonClose responsive onClick={goBack}>Close</ButtonClose>
            <ButtonDownload responsive>Print</ButtonDownload>
            { booking?.cancelled === null && <ButtonCancel responsive onClick={cancelBooking}>Cancel</ButtonCancel> }
        </Row>
    )
}

class CoWorkingBookingView extends Component {
    static contextType = PopupContext;

    constructor(props) {
        super(props);

        this.state = {
            booking: null,
            data: null,
            space: null,
            quote: null,
        }
    }

    componentDidMount() {
        this.fetchBooking();
    }

    fetchBooking() {
        coWorkingApi.getCoWorkingBooking(this.props.id).then(({ data }) => {
            this.setState({ booking: data }, () => {
                this.fetchCoWorkingSpace();
            })
        });
    }

    fetchCoWorkingSpace() {
        coWorkingApi.getCoWorkingSpace(this.state.booking?.co_working_space_id).then(({ data }) => {
            this.setState({ space: data })
        })
    }

    changeLocation(url) {
        window.location.href = url;
    }

    getFeaturedImage() {
        const image = this.state.space?.content?.space_feature_image?.[0];

        if (image?.file_name === undefined) return '';

        return MediaHelper.formatPublicPath(`/images/${image?.file_name}`);
    }

    getTimeOfDay() {
        let from = `Nothing Selected`;

        const {
            afternoon_session,
            morning_session,
        } = this.state.booking;

        if (morning_session == true) {
            from = 'Morning'
        }

        if (afternoon_session == true) {
            from = 'Afternoon'
        }

        if (morning_session == true && afternoon_session == true) {
            from = 'All Day'
        }

        return from;
    }

    getLocation() {
        const { name, address_one, address_two, address_post_code, address_city } = this.state?.space?.office_building || {
            name: '',
            address_one: '',
            address_two: '',
            address_post_code: '',
            address_city: ''
        };

        let string = [
            name,
            address_one,
            address_two,
            address_post_code,
            address_city
        ].filter(e => e !== undefined && e !== null && e?.length > 0);

        return string.join(', ');
    }

    render() {
        if (this.state.booking === null) return null;

        const featuredImage = this.getFeaturedImage();
        const location = this.getLocation();

        const quote = this.state.booking?.saved_quote || this.state.booking?.receipt;

        return (
            <Layout 
                theme="dark"
                topLeft={<Welcome title={<Container.Text>
                    <Row gap='10px' wrap>
                        Co-Working Booking: <Container.Text color="#FF6933">{ this.state.space?.name }: #{ this.state.booking?.id }</Container.Text>
                    </Row>
                </Container.Text>} subtitle={`Your Co-Working Pass`}/>}
                topRight={
                    <TopRightBar booking={this.state.booking} fetch={this.fetchBooking.bind(this)}/>
                }
            >
                <MinMaxLayout
                    main={
                        <List gap="40px">
                            { this.state.booking.cancelled !== null && <StatusBar
                                status="error"
                                head="Booking Cancelled"
                                content={
                                    <p>
                                        This booking has been cancelled on <b>{ getDSTLocalTime(this.state.booking?.cancelled).format('HH:mm D/M/YYYY') }</b> by <b>{this.state.booking?.cancelled_by_user?.name}</b>
                                    </p>
                                }
                            /> }
                            <div className="booking-view">
                                <List gap="40px" divider={<Divider/>} className="booking-view__child">
                                    <Container>
                                        <Container.Header>
                                            <Container.Text color="#FF6933" fontSize="18px">Booking Details</Container.Text>
                                        </Container.Header>

                                        <Container.Content> 
                                            <List gap="20px">
                                                <div className="booking-view__image" style={{ backgroundImage: `url('${featuredImage}')` }}></div>

                                                <LabelContainer label='Booking Type'>
                                                    { this.state.booking?.co_working_space?.name }
                                                </LabelContainer>

                                                <LabelContainer label='Booking Location'>
                                                    { location }
                                                </LabelContainer>

                                                <LabelContainer label="Booking Date & Duration">
                                                    { dayjs(this.state.booking?.day).format('DD/MM/YYYY') } - { this.getTimeOfDay() }
                                                </LabelContainer>

                                                <List gap="20px">
                                                    <LabelContainer label="Number of attendees">
                                                        { this.state.booking?.no_attendees }
                                                    </LabelContainer>
                                                </List>
                                            </List>
                                        </Container.Content>
                                    </Container>

                                    <BillingDetails
                                        viewOnly
                                        booker={quote?.billing_profile}
                                    />
                                </List>

                                <Container className="booking-view__child">
                                    <Container.Header>
                                        <Container.Text color="#FF6933" fontSize="18px">Your Order</Container.Text>
                                    </Container.Header>

                                    <Container.Content>
                                        <List gap="40px">
                                            <div className="agree-box">
                                                <Summary
                                                    costs={this.state.booking?.saved_quote}
                                                    receipt={this.state.booking?.receipt}
                                                />
                                                <div className="agree-box__content">
                                                    <div className="agree-box__details">
                                                        <div className="agree-box-details__detail">
                                                            <p>Credits Used</p>
                                                            <span>{ quote?.credits_used }</span>
                                                        </div>
                                                        <div className="agree-box-details__detail">
                                                            <p>BACS Due</p>
                                                            <span>£{ quote?.total }</span>
                                                        </div>
                                                    </div>

                                                    { this.state.booking?.receipt && <ButtonDownload color="black">Download Reciept</ButtonDownload> }
                                                </div>
                                            </div>

                                            <Container>
                                                <Container.Header>
                                                    <Container.Text fontSize="18px" color="#FF6933">Booking Information</Container.Text>
                                                </Container.Header>

                                                <Container.Content>
                                                    <Container.Text fontSize="14px" lightThemeColor="#24191F" darkThemeColor="white" html={this.state.booking?.saved_quote?.meta?.co_working_space?.booking_information}></Container.Text>
                                                </Container.Content>
                                            </Container>

                                            <Container>
                                                <Container.Header>
                                                    <Container.Text fontSize="18px" color="#FF6933">Contact Us</Container.Text>
                                                </Container.Header>

                                                <Container.Content>
                                                    <Container.Text fontSize="14px" lightThemeColor="#24191F" darkThemeColor="white">
                                                        +44 (0)1226 720 700

                                                        bookings@barnsleydmc.co.uk

                                                        DMC
                                                        County Way
                                                        Barnsley
                                                        S70 2JW
                                                        UK
                                                    </Container.Text>
                                                </Container.Content>
                                            </Container>
                                        </List>
                                    </Container.Content>
                                </Container>
                            </div>
                        </List>
                    }
                />
            </Layout>    
        )
    }
}

const el = document.getElementById('coworking-booking-view');

if (el) {
    ReactDOM.render(<CoWorkingBookingView id={el.getAttribute('data-id')}/>, el);
}
